import { BaseFieldType } from "@api/graphql/types-and-hooks";
import { TreatmentPlanCheckbox } from "@components/ReportField/TreatmentPlanField/inputs/TreatmentPlanCheckbox";
import { TreatmentPlanDate } from "@components/ReportField/TreatmentPlanField/inputs/TreatmentPlanDate";
import { TreatmentPlanDatetime } from "@components/ReportField/TreatmentPlanField/inputs/TreatmentPlanDatetime";
import { TreatmentPlanSelect } from "@components/ReportField/TreatmentPlanField/inputs/TreatmentPlanSelect";
import { ReportFieldInput } from "@components/ReportField/inputs/ReportFieldInput";
import { ReportFieldWysiwyg } from "@components/ReportField/inputs/ReportFieldWysiwyg";
import { ReportFieldInputBaseProps } from "@components/ReportField/types";

const TREATMENT_PLAN_FIELD_INPUTS: Partial<Record<BaseFieldType, React.FC<ReportFieldInputBaseProps>>> = {
  [BaseFieldType.SimpleText]: ReportFieldInput,
  [BaseFieldType.Wysiwyg]: ReportFieldWysiwyg,
  [BaseFieldType.Select]: TreatmentPlanSelect,
  [BaseFieldType.Radio]: TreatmentPlanSelect,
  [BaseFieldType.Checkbox]: TreatmentPlanCheckbox,
  [BaseFieldType.Date]: TreatmentPlanDate,
  [BaseFieldType.Datetime]: TreatmentPlanDatetime,
};

export const getTreatmentPlanFieldInput = (
  fieldType: BaseFieldType | string,
): React.FC<ReportFieldInputBaseProps> | undefined => TREATMENT_PLAN_FIELD_INPUTS[fieldType as BaseFieldType];
